import { useCallback } from "react";
import { Select } from "src/components/shared/MantineCombobox";
import { useDispatch, useSelector } from "src/redux/hooks";
import {
  setIsEmpty,
  setReportMode,
  type TReportMode,
} from "src/redux/slices/entriesGeneratorSlice";

import { reportModeData } from "./Section.utils";

const ReportModeSelect = () => {
  const dispatch = useDispatch();
  const reportMode = useSelector(
    state => state.entriesGeneratorSlice.reportMode,
  );

  const handleChange = useCallback(
    (value: TReportMode) => {
      dispatch(setIsEmpty(true));
      dispatch(setReportMode(value));
    },
    [dispatch],
  );

  return (
    <Select data={reportModeData} value={reportMode} onChange={handleChange} />
  );
};

export default ReportModeSelect;
